<template>
    <v-dialog v-model="localValue" max-width="400" persistent>
        <v-card>
            <v-card-title>
                <span>{{ Translate(title) }}</span>
                <v-spacer></v-spacer>
                <v-btn icon color="secondary" @click="cancel">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-card-title>
            <v-card-text class="pt-4 pb-2">
                <v-form ref="linkForm" v-model="isFormValid">
                    <v-text-field
                        v-model="editableWebAddress"
                        :label="Translate('Web Address (URL)')"
                        outlined
                        dense
                        hide-details="auto"
                        class="mb-4"
                        :rules="webAddressRules"
                        autocomplete="off"
                    ></v-text-field>
                    <v-text-field
                        v-model="editableDisplayText"
                        :label="Translate('Display As')"
                        outlined
                        dense
                        hide-details="auto"
                        :rules="displayTextRules"
                        autocomplete="off"
                    ></v-text-field>
                </v-form>
            </v-card-text>
            <v-card-actions class="pa-4">
                <v-spacer></v-spacer>
                <v-btn text @click="cancel">
                    {{ Translate("Cancel") }}
                </v-btn>
                <v-btn color="primary" depressed @click="save" :disabled="!isFormValid">
                    {{ Translate("Save") }}
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import methods from '@/Shared/methods';
export default {
    name: "RoosterLinkModal",
    components: {
    },
    props: {
        value: Boolean,
        webAddress: {
            type: String,
            default: ""
        },
        displayText: {
            type: String,
            default: ""
        }
    },
    data() {
        return {
            editableWebAddress: "",
            editableDisplayText: "",
            isFormValid: false,
            webAddressRules: [
                v => !!v || this.Translate('Web address is required.'),
                v => /^((https?|ftp):\/\/)?([a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?\.)+[a-zA-Z]{2,}(?:\/[^ "]*)*$/.test(v) || this.Translate('Must be a valid web address (e.g., example.com or http://example.com)'),
            ],
            displayTextRules: [
                v => !!v || this.Translate('Display text is required.'),
            ],
        };
    },
    computed: {
        localValue: {
            get() {
                return this.value;
            },
            set(val) {
                // Standard event for v-model
                this.$emit("input", val);
            }
        },
        title() {
            // Dynamic title based on whether props suggest an existing link
            return (this.webAddress || this.displayText) ? "Edit Link" : "Add Link";
        }
    },
    watch: {
        value(isDialogVisible) {
            if (isDialogVisible) {
                this.populateFields();
            } else {
                // Reset validation when dialog closes
                if (this.$refs.linkForm) {
                    this.$refs.linkForm.resetValidation();
                }
            }
        },
        // Watch for prop changes to update local data if dialog is already open
        webAddress(newValue) {
            if (this.value) {
                this.editableWebAddress = newValue;
            }
        },
        displayText(newValue) {
            if (this.value) {
                this.editableDisplayText = newValue;
            }
        }
    },
    mounted() {
        // If the dialog is intended to be open on mount, populate fields.
        if (this.value) {
            this.populateFields();
        }
    },
    methods: {
        ...methods,
        populateFields() {
            this.editableWebAddress = this.webAddress;
            this.editableDisplayText = this.displayText;
            // Reset validation state when (re)populating fields
            if (this.$refs.linkForm) {
                this.$refs.linkForm.resetValidation();
            }
        },
        cancel() {
            this.localValue = false; // This will trigger the 'input' event due to the setter
            this.$emit("cancel");
        },
        save() {
            if (this.$refs.linkForm.validate()) {
                this.$emit("save", {
                    webAddress: this.editableWebAddress,
                    displayText: this.editableDisplayText
                });
                this.localValue = false; // Close dialog on save
            }
        }
    }
};
</script>
